export { default as NavBar } from  './NavBar';